import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	activities: {
		display: 'flex',
		flex: '0 1 480px',
		flexDirection: 'column',
		gap: SPACE[8],
		minWidth: 0,
		[THEME.queries.lg]: {
			flex: 'none',
			width: '100%',
		},
	},
	fileInput: {
		display: 'none',
	},
	gamification: {
		alignItems: 'flex-start',
		display: 'flex',
		gap: SPACE[32],
		paddingBottom: SPACE[24],
		[THEME.queries.lg]: {
			flexDirection: 'column',
		},
	},
	memes: {
		display: 'flex',
		flex: '1 1 540px',
		flexDirection: 'column',
		gap: SPACE[12],
		minWidth: 0,
		paddingTop: SPACE[32],
		[THEME.queries.lg]: {
			flex: 'none',
			paddingTop: 0,
			width: '100%',
		},
	},
});
